import { Form } from 'antd';

const ExampleNetwork = () => {
    
    return (
      <div id="epp" className="w-full mt-5">
      <Form.Item labelCol={{ span: 24 }} label="Example Network">
        <div>
            {' '}
        <a
            href="https://gutmicro.net/?includeNeighbourConnections=true&visualize=true&networkType=Species+Interactions&networkName=Diseases&cohortDiseaseName=NAFLD-NonDiabetic&pruning=0&locations=Species&nodeLimit=10&search=Ruminococcus+bromii+2%7C%2CDorea+longicatena+1&correlation=both&categoryId=18"
          target="_blank"
          rel="noopener noreferrer"
        >
          Case Study 2 (NAFLD-Non Diabetic)
        </a>
        </div>
      </Form.Item>
        </div>
    );
  };


export default ExampleNetwork;
  